module.exports = __webpack_public_path__ + "static/img/package-icon.99900edb.svg";